import React from 'react';
import styled from 'styled-components';

import { TransformationType } from 'shared/types/transformation';
import { getReadableTransformationType } from 'shared/utils/transformation';

import { SafelistNavContent } from './SafelistNavContent';
import { TransformationNavContentProps } from './types';

const StyledContainer = styled.div``;

const StyledTransformationTypeContainer = styled.div`
  &:not(:last-child) {
    margin-bottom: 0.666666667rem;
  }
`;

const StyledTransformationName = styled.h5`
  margin: 0 0 0.333333333rem;
  font-size: 1rem;
  font-weight: 400;
  color: #8d9199;
`;

const StyledTransformationValueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 0.666666667rem;
`;

const StyledTransformationValue = styled.span`
  &:not(:last-child) {
    margin-bottom: 0.416666667rem;
  }
`;

const renderNavContent = (values: TransformationNavContentProps['values']) => (
  Object.entries(values).map(([transformationName, transformationValues]) => {
    if (!transformationValues) {
      return null;
    }

    let content = null;

    if (transformationName === TransformationType.SAFELIST_LIBRARY) {
      content = <SafelistNavContent safelistLibraryGuids={transformationValues} />;
    } else {
      content = transformationValues.map((value) => (
        <StyledTransformationValue key={value}>{value}</StyledTransformationValue>
      ));
    }

    return (
      <StyledTransformationTypeContainer key={transformationName}>
        <StyledTransformationName>{getReadableTransformationType(transformationName)}</StyledTransformationName>
        <StyledTransformationValueWrapper>
          {content}
        </StyledTransformationValueWrapper>
      </StyledTransformationTypeContainer>
    );
  })
);

const TransformationNavContent = ({
  values,
}: TransformationNavContentProps) => (
  <StyledContainer>
    {renderNavContent(values)}
  </StyledContainer>
);

export default TransformationNavContent;
